import { useEffect, useState } from "react";
import { AdminHeader } from "../../../components/adminHeader/adminHeader";
import { useParams } from "react-router";
import { PageLoader } from "../../../components/loader/pageLoader";
import { Image } from "../../../components/image/image";
import { DeleteIcon, EditIcon } from "../../../assets/icons";
import { useConfirmPopup } from "../../../components/popup/confirmPopup/confirmPopup";
import { usePopup } from "../../../components/popup/popup";
import { Button } from "../../../components/button/button";
import { Input } from "../../../components/input/input";
import { UploadFile } from "../../../components/uploadFile/uplodeFile";
import CheckListAPI from "../../../api/CheckListAPI";
import classNames from "classnames";

import styles from "./cafeChecklistSettings.module.css";
import { Separator } from "../../../components/separator/separator";

import { Text } from "../../../components/text/text";

export const CafeChecklistSettings = () => {
    const { cafeId } = useParams();

    const [zones, setZones] = useState([]);

    const [currentElement, setCurrentElement] = useState(null);
    const onDelete = () => {
        if (!currentElement) return;

        CheckListAPI
            .deleteChecklistCategory(currentElement)
            .then(() => {
                setZones(prev => prev.filter(data => data.id !== currentElement));
            })
            .catch(console.error);
    }

    const onDeleteAll = () => {
        CheckListAPI
            .deleteAllChecklistCategories(cafeId)
            .then(() => {
                setZones([]);
            })
            .catch(console.error);
    }

    const [DeletePopup, openDeletePopup] = useConfirmPopup(
        "Подтвердите действие",
        "Вы уверены, что хотите удалить зону?",
        onDelete
    )

    const [DeleteAllPopup, openDeleteAllPopup] = useConfirmPopup(
        "Подтвердите действие",
        "Вы уверены, что хотите удалить все зоны? Все задачи чек-листов будут также удалены.",
        onDeleteAll
    )

    const [loading, setLoading] = useState(true);
    useEffect(() => {
        CheckListAPI
            .fetchChecklistCategories(cafeId)
            .then(setZones)
            .catch(console.error)
            .finally(() => setLoading(false));
    }, [cafeId]);


    const [Popup, openPopup, closePopup] = usePopup();

    const [name, setName] = useState("");
    const [icon, setIcon] = useState(null);

    const [nameError, setNameError] = useState(false);

    useEffect(() => setNameError(false), [name]);

    const [mode, setMode] = useState("create");
    const validate = () => {
        let error = false;

        if (name.trim().length === 0) {
            setNameError(true);
            error = true;
        }

        return error;
    }

    const [creating, setCreating] = useState(false);
    const onSave = async () => {
        if (validate()) return;

        setCreating(true);
        if (mode === "create") {
            try {
                let result = await CheckListAPI.createChecklistCategory(cafeId, name);

                if (icon) {
                    result = await CheckListAPI.uploadChecklistCategoryImage(result.id, icon);
                }

                setZones(prev => [...prev, result]);
                closePopup();
            } catch (error) {
                if (error.status === 409) {
                    setNameError(true);
                }
                console.log(error);
            }
        } else {
            try {
                let res = await CheckListAPI.updateChecklistCategory(currentElement, name);

                if (icon) {
                    try {
                        await CheckListAPI.deleteChecklistCategoryImage(currentElement);
                    } catch (err) {
                        if (err.status !== 404)
                            throw err;
                    }
                    res = await CheckListAPI.uploadChecklistCategoryImage(currentElement, icon);
                }

                setZones(prev => prev.map(el => el.id === currentElement ? res : el));
                closePopup();
            } catch (error) {
                if (error.status === 500) {
                    setNameError(true);
                }
                console.log(error);
            }

        }

        setCreating(false);
    }

    if (loading) {
        return <PageLoader />;
    }

    return (
        <>
            <AdminHeader title="Зоны чек-листов" />

            <div className={styles.zones}>
                {
                    zones.map((data) => (
                        <div key={data?.id} className={styles.zone_container}>
                            <Image
                                width="80px"
                                height="80px"
                                objectFit="contain"
                                src={data?.image}
                            />
                            <Text as="div" variant="body" className={styles.zone_name} size={14} weight={700}>{data?.text}</Text>
                            <EditIcon
                                className={styles.edit}
                                onClick={() => {
                                    setMode("edit");
                                    setName(data?.text);
                                    setIcon(null);
                                    setCurrentElement(data?.id);
                                    openPopup();
                                }}
                            />
                            <DeleteIcon
                                className={styles.delete}
                                onClick={() => {
                                    setCurrentElement(data?.id);
                                    openDeletePopup();
                                }}
                            />
                        </div>
                    ))
                }
            </div>

            <Separator />

            <div className={styles.fixed_buttons}>
                <Button
                    text="Добавить зону"
                    onClick={() => {
                        setMode("create");
                        setName("");
                        setIcon(null);
                        openPopup();
                    }}
                />

                <Button
                    text="Удалить все зоны"
                    type="destructive"
                    onClick={openDeleteAllPopup}
                />
            </div>

            <Popup>
                <Text as="div" variant="h1" className={styles.title} >
                    {mode === "create" ? "Создать новую зону" : "Редактировать зону"}
                </Text>

                <div className={classNames(styles.input, { [styles.error]: nameError })}>
                    <Text as="div" variant="caption" className={styles.input_label} >Название зоны</Text>
                    <Input
                        type="text"
                        value={name}
                        setValue={setName}
                        error={nameError}
                    />
                </div>

                <div className={classNames(styles.input)}>
                    <Text as="div" variant="caption" className={styles.input_label} >{mode === "create" ? "Иконка зоны (необязательно)" : "Новая иконка зоны (необязательно)"}</Text>
                    <UploadFile
                        accept="image/*"
                        selectedFile={icon}
                        setSelectedFile={setIcon}
                    />
                </div>

                <div className={styles.buttons}>
                    <Button
                        text="Отмена"
                        type="hint"
                        view="thin"
                        onClick={closePopup}
                    />
                    <Button
                        disabled={creating}
                        text="Сохранить"
                        view="thin"
                        onClick={onSave}
                    />
                </div>
            </Popup>

            {DeletePopup}
            {DeleteAllPopup}
        </>
    );
}